import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "related-games-selector"
}
const _hoisted_2 = { class: "related-games-checkboxes" }
const _hoisted_3 = ["value", "checked", "disabled", "onChange"]
const _hoisted_4 = { class: "checkbox-label" }

import { computed } from 'vue';
import { useRelatedGames } from '../composables/useRelatedGames';


const __default__ = {
  name: 'RelatedGamesSelector',
};

interface Props {
  currentGameSlug: string;
  selectedGames: string[];
  isProcessing?: boolean;
}

interface Emits {
  (e: 'update:selectedGames', games: string[]): void;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    currentGameSlug: {},
    selectedGames: {},
    isProcessing: { type: Boolean, default: false }
  },
  emits: ["update:selectedGames"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { getRelatedGamesSync } = useRelatedGames();

const relatedGames = computed(() => {
  return getRelatedGamesSync(props.currentGameSlug);
});

const handleToggle = (gameSlug: string) => {
  const newSelection = [...props.selectedGames];
  const index = newSelection.indexOf(gameSlug);
  
  if (index > -1) {
    newSelection.splice(index, 1);
  } else {
    newSelection.push(gameSlug);
  }
  
  emit('update:selectedGames', newSelection);
};

return (_ctx: any,_cache: any) => {
  return (relatedGames.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relatedGames.value, (game) => {
            return (_openBlock(), _createElementBlock("label", {
              key: game.slug,
              class: _normalizeClass(["related-game-checkbox", { 'disabled': _ctx.isProcessing }])
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                value: game.slug,
                checked: _ctx.selectedGames.includes(game.slug),
                disabled: _ctx.isProcessing,
                onChange: ($event: any) => (handleToggle(game.slug))
              }, null, 40, _hoisted_3),
              _createElementVNode("span", _hoisted_4, _toDisplayString(game.name), 1)
            ], 2))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})